import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { formatPriceCents } from '@gobingebox/shared';
import { posterGradient } from '@/lib/posters';
import { Alert } from '@/components/ui/Alert';
import { Button } from '@/components/ui/Button';
import { catalogApi } from '@/features/catalog/api';

export function ProductPage() {
  const { productSlug = '' } = useParams<{ productSlug: string }>();
  const { data, isLoading, isError } = useQuery({
    queryKey: ['product', productSlug],
    queryFn: () => catalogApi.product(productSlug),
  });

  if (isLoading) return <div className="container-page py-16 text-sm text-ink-faint">Loading…</div>;
  if (isError || !data) {
    return (
      <div className="container-page py-20 text-center text-ink-muted">
        Product not found.{' '}
        <Link to="/store" className="font-semibold text-brand-soft underline">Back to Store</Link>
      </div>
    );
  }

  const p = data.product;
  return (
    <div className="container-page grid gap-8 py-12 md:grid-cols-2">
      <div
        className="aspect-square w-full rounded-card border border-border"
        style={p.images[0] ? { backgroundImage: `url(${p.images[0]})`, backgroundSize: 'cover' } : { backgroundImage: posterGradient(p.id) }}
      />
      <div>
        <h1 className="font-display text-3xl font-bold text-ink">{p.name}</h1>
        <p className="mt-2 font-display text-2xl font-extrabold text-brand-soft">
          {formatPriceCents(p.priceCents)}
        </p>
        <p className="mt-4 text-ink-muted">{p.description}</p>
        <div className="mt-7 space-y-3">
          <Button size="lg" disabled className="w-full sm:w-auto">
            Add to cart
          </Button>
          <Alert tone="info">Cart &amp; secure checkout (with your subscriber discount) arrive in the billing phase.</Alert>
        </div>
      </div>
    </div>
  );
}
